import { ArdoqId } from '@ardoq/api-types';

export type SlideLegendState = {
  currentSlideId: ArdoqId | null;
  /**
   * The legend on screen, which is also what a slide the viewer has never
   * visited inherits when they first arrive at it.
   */
  legendActive: boolean;
  legendActiveBySlideId: Partial<Record<ArdoqId, boolean>>;
};

export const DEFAULT_SLIDE_LEGEND_STATE: SlideLegendState = {
  currentSlideId: null,
  legendActive: false,
  legendActiveBySlideId: {},
};

export const isSlideLegendActive = (
  { legendActive, legendActiveBySlideId }: SlideLegendState,
  slideId: ArdoqId
): boolean => legendActiveBySlideId[slideId] ?? legendActive;

/**
 * Arriving at a slide settles its legend, whether the viewer inherited it or
 * had set it before: a legend they have already seen on a slide is theirs, so
 * revisiting it shows the same thing rather than whatever the slide they came
 * from happened to have.
 */
export const settleLegendOnSlide = (
  state: SlideLegendState,
  slideId: ArdoqId
): SlideLegendState => {
  const legendActive = isSlideLegendActive(state, slideId);
  return {
    currentSlideId: slideId,
    legendActive,
    legendActiveBySlideId: {
      ...state.legendActiveBySlideId,
      [slideId]: legendActive,
    },
  };
};

export const setSlideLegend = (
  state: SlideLegendState,
  legendActive: boolean
): SlideLegendState => {
  const { currentSlideId } = state;
  if (currentSlideId === null) return { ...state, legendActive };
  return {
    ...state,
    legendActive,
    legendActiveBySlideId: {
      ...state.legendActiveBySlideId,
      [currentSlideId]: legendActive,
    },
  };
};
